import { render, staticRenderFns } from "./ListTypes.vue?vue&type=template&id=2480266c&scoped=true"
import script from "./ListTypes.vue?vue&type=script&lang=js"
export * from "./ListTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2480266c",
  null
  
)

export default component.exports